import type { InclusionOption } from "app/pages/sales-intelligence/types/commonMaps";

export const commonKeys = {
    clear: "common.clear",
    and: "common.and",
    thanks: "si.common.thanks",
    failed: "si.common.failed",
    gainAccess: "si.common.gain_access",
    inclusion: (option: InclusionOption) => `si.common.inclusions.${option}` as const,

    elapsed: {
        minutesAgo: "si.common.minutes_ago",
        hoursAgo: "si.common.hours_ago",
        daysAgo: "si.common.days_ago",
    },

    filters: {
        range: {
            minPlaceholder: "si.common.filters.range.min.placeholder",
            maxPlaceholder: "si.common.filters.range.max.placeholder",
        },
    },
} as const;
